import { useScopedAppFlagStore } from '@frontend/scope';
import { useScheduleRequestFeaturesAccess } from './use-schedule-request-features-access';

export const usePreferenceBasedRequestsAccess = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isPreferenceBasedRequestEnabled = getFeatureFlagValue('schedule-air-preference-requests', 'ALL');
  const { hasScheduleRequestFeaturesAccess } = useScheduleRequestFeaturesAccess();

  return {
    hasPreferenceBasedRequestsAccess: hasScheduleRequestFeaturesAccess && isPreferenceBasedRequestEnabled,
  };
};
